<template>
    <div id="contact">
        <section class="section p-0 bg d-flex align-items-center justify-content-center">
            <div class="container text-center"><h1 class="text-white">Контакты</h1><Breadcrumbs title="Контакты"/></div>
        </section>
        <section class="section mt-2 pb-0">
            <div class="container">
                <div class="row row-grid">
                    <div class="col-lg-5">
                        <div class="border-bottom mt-5">
                            <p class="mb-4 pl-4"
                               style="border-left: 0.3em solid var(--default);">
                                <span class="h5">АДРЕС:</span><br>
                                {{$root.address}}
                            </p>
                        </div>
                        <div class="border-bottom">
                            <p class="my-4 pl-4"
                               style="border-left: 0.3em solid var(--orange);">
                                <span class="h5">Телефон:</span><br>
                                {{$root.phone}}
                            </p>
                        </div>
                        <div>
                            <p class="my-4 pl-4"
                               style="border-left: 0.3em solid var(--primary);">
                                <span class="h5">Почта:</span><br>
                                {{$root.email}}
                            </p>
                            <base-button type="neuitral" v-b-toggle.collapse-b
                                         style="font-weight:500;"
                                         class="ml-4">Дополнительная почта</base-button>
                            <b-collapse id="collapse-b" class="mt-2" v-for="item in $root.emailExtra" :key="item.ID">
                                <card v-html="item" class="p-4"></card>
                            </b-collapse>
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <h2 class="h4" style="text-align:center">Напишите ваш вопрос</h2>
                        <ContactForm></ContactForm>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import ContactForm from "@/components/ContactForm.vue";
    export default {
        components: {
            ContactForm,
        },
        data() {
            return {
                
            };
        },
        methods: {
            async loadInfo() {
                let params_2 = new Map();
                params_2.set('entity', 'pages');
                params_2.set('code', 'contacts');

                let seo = await this.$root.loadContent(params_2)
                this.$root.title = seo[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = seo[0]['SEO']['ELEMENT_META_DESCRIPTION'];
            },
        },
        created() {
            this.loadInfo()
        },
    };
</script>
<style>
    #contact .section-shaped{
        display: none;
    }
    #contact .section-contact-us .row{
        margin-top: 0px !important;
    }
    #contact .section-contact-us .row .col-lg-8{
        flex: 0 0 100%;
        max-width: 100%;
    }
</style>